import Checked from '../Icon/EditorDoneIcon.js';

//
var script = {
  name: 'ColorCard',
  components: {
    EditorDoneIcon: Checked
  },
  props: {
    color: {
      type: String,
      default: '#000'
    },
    selected: {
      type: String,
      default: '#000'
    }
  },
  computed: {
    styles() {
      return {
        'background-color': this.color
      };
    }

  },
  methods: {
    onClick() {
      this.$emit('color-selected', this.color);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ColorPicker/ColorCard.vue_rollup-plugin-vue=script.js